import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { DELETE, GET, newFetch, POST, PUT } from '../../../../helpers/fetch';
import { to12Hr } from '../../../../helpers/moment';

import Modal from '../../../../components/Modal';
import AlertService from '../../../../components/SweetAlert';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';

import { config } from '../../../../config/index';
import docImg from '../../../../assets/icons/document.png';
const { API_URL, SERVER_URL } = config;

const StatusTab = ({
  associate,
  activeSchedule,
  associateStatus,
  setBackDropSidebar,
  activeClient,
  associateStatusLogs,
  activeSite,
  fetchSchedules,
  setActiveSidebar,
}) => {
  const token = localStorage.getItem('token');
  const type = localStorage.getItem('type');

  const [statuses, setStatuses] = useState([]);

  const [openEditStatusModal, setOpenEditStatusModal] = useState(false);
  const [openEditRoleModal, setOpenEditRoleModal] = useState(false);
  const [confirmApplyShiftModal, setConfirmApplyShiftModal] = useState(false);
  const [date, setDate] = useState(null);
  const [status, setStatus] = useState(0);
  const [statusRole, setStatusRole] = useState(0);
  const [timeIn, setTimeIn] = useState(null);
  const [timeOut, setTimeOut] = useState(null);
  const [breakIn, setBreakIn] = useState(null);
  const [breakOut, setBreakOut] = useState(null);
  const [isOvertime, setIsOvertime] = useState(false);
  const [isUndertime, setIsUndertime] = useState(false);
  const [secondRollCall, setSecondRollCall] = useState(0);
  const [dateTimeIn, setDateTimeIn] = useState(null);
  const [dateTimeOut, setDateTimeOut] = useState(null);
  const [dateBreakIn, setDateBreakIn] = useState(null);
  const [dateBreakOut, setDateBreakOut] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [totalBreak, setTotalBreak] = useState(null);
  const [clickYesAssignRole, setClickYesAssignRole] = useState(false);
  const [isOvertimeAfter, setIsOvertimeAfter] = useState(false);
  const [isOvertimeBefore, setIsOvertimeBefore] = useState(false);
  const [remarksMps, setRemarksMps] = useState('');
  const [totalOvertime, setTotalOvertime] = useState(0);
  const [dayOfWeek, setDayOfWeek] = useState('');
  const [exceedOvertime, setExceedOverTime] = useState(false);
  const [exceedWorkHours, setExceedWorkHours] = useState(false);
  const dateTimeInHandler = (e) => setDateTimeIn(e.target.value);
  const dateTimeOutHandler = (e) => setDateTimeOut(e.target.value);
  const dateBreakInHandler = (e) => setDateBreakIn(e.target.value);
  const dateBreakOutHandler = (e) => setDateBreakOut(e.target.value);
  const { associate_roles } = associate;

  const padding = 110; // adjust this to your needs
  let height = 375 + padding;
  let heightPx = height + 'px';
  let heightOffset = height / 2;
  let offsetPx = heightOffset + 'px';

  const style = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    // height: heightPx, // set height
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '53%',
  };

  const roleStyle = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '30%',
    maxWidth: '40rem',
  };

  const handleOpenModal = () => {
    setOpenEditStatusModal(true);
    setBackDropSidebar(false);

    if (associateStatus) {
      const isDayShift = moment(
        `${associateStatus.schedule.date} ${activeSchedule.shift.start_time}`
      ).isBefore(
        moment(
          `${associateStatus.schedule.date} ${activeSchedule.shift.end_time}`
        )
      );

      setDate(associateStatus.schedule.date);
      setStatus(associateStatus.statusObj.id);
      setStatusRole(associateStatus.associate_role_id);
      setIsOvertime(associateStatus.is_overtime);
      setIsUndertime(associateStatus.is_undertime);
      setTotalBreak(associateStatus.total_break);

      setIsOvertimeAfter(associateStatus.is_overtime_after || false);
      setIsOvertimeBefore(associateStatus.is_overtime_before || false);
      setRemarksMps(associateStatus.remarks || '');

      if (associateStatus.time_in) {
        setTimeIn(moment(associateStatus.time_in).format('HH:mm:ss'));
        setDateTimeIn(moment(associateStatus.time_in).format('YYYY-MM-DD'));
      } else {
        setTimeIn('');
        setDateTimeIn(associateStatus.schedule.date);
      }

      if (associateStatus.time_out) {
        setTimeOut(moment(associateStatus.time_out).format('HH:mm:ss'));
        setDateTimeOut(moment(associateStatus.time_out).format('YYYY-MM-DD'));
      } else {
        setTimeOut('');
        setDateTimeOut(
          isDayShift
            ? associateStatus.schedule.date
            : moment(associateStatus.schedule.date, 'YYYY-MM-DD')
                .add(1, 'days')
                .format('YYYY-MM-DD')
        );
      }

      if (associateStatus.break_in) {
        setBreakIn(moment(associateStatus.break_in).format('HH:mm:ss'));
        setDateBreakIn(moment(associateStatus.break_in).format('YYYY-MM-DD'));
      } else {
        setBreakIn('');
        setDateBreakIn(associateStatus.schedule.date);
      }

      if (associateStatus.break_out) {
        setBreakOut(moment(associateStatus.break_out).format('HH:mm:ss'));
        setDateBreakOut(moment(associateStatus.break_out).format('YYYY-MM-DD'));
      } else {
        setBreakOut('');
        setDateBreakOut(associateStatus.schedule.date);
      }
    }
  };

  const fetchStatuses = async () => {
    let api_path = `/attendanceStatus`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let statuses = response.data;
      setStatuses(statuses);
    }
  };

  const fetchRollCall = async () => {
    const api_path = `/admin/setting/1`;
    const response = await newFetch(GET, api_path);
    if (response.success) {
      const data = response.data;
      setSecondRollCall(data.value);
    }
  };

  const cancelShiftHandler = async () => {
    if (
      associate &&
      activeSchedule &&
      (await AlertService.confirm(
        '',
        "Are you sure you want to cancel this employee's shift?"
      ))
    ) {
      let api_path = `/associate/${associate.id}/schedule/${activeSchedule.id}`;
      let response = await newFetch(DELETE, api_path);

      ToastUtil.success(response.message);
      if (response.success) {
        setActiveSidebar(false);
        await fetchSchedules(activeSite.id);
      }
    }
  };

  const assignShiftHandler = async () => {
    setConfirmApplyShiftModal(false);
    try {
      let url = `${API_URL}/associate/shifts/${activeSchedule.id}/assign`;

      try {
        let data = {
          associate_ids: [associate.id],
          associate_role_id: selectedRole,
        };

        let response = await fetch(url, {
          mode: 'cors',
          method: 'POST',
          body: JSON.stringify(data),
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        let responseData = await response.json();

        if (responseData.success) {
          ToastUtil.success(responseData.message);
          setActiveSidebar(false);
          await fetchSchedules(activeSite.id);
        } else {
          ToastUtil.error(
            responseData.data.fail.find(
              (failAssociate) => failAssociate.associate_id === associate.id
            ).message
          );
        }
      } catch (error) {
        console.log(error);
      }
    } catch (error) {}
  };

  // const assignAsFixedShiftHandler = async () => {
  // const  = await AlertService.confirm('', 'Are you sure you want to assign this Associate to this shift as Fixed Shift?')
  //   if (
  //     isConfirmed
  //   ) {
  //     let api_path = `/associate/shifts/${activeSchedule.id}/assign_fixed`
  //     let response = await newFetch(POST, api_path, {
  //       associate_id: associate.id
  //     })

  //     if (response.success) {
  //       ToastUtil.success(response.message)
  //       window.location.reload()
  //     }
  //   }
  // }

  const assignOverrideShiftHandler = async () => {
    const isConfirmed = await AlertService.confirm(
      '',
      'Are you sure you want to assign this Employee to this shift? This will override all the scheduling rules.'
    );
    if (isConfirmed) {
      let api_path = `/associate/shifts/${activeSchedule.id}/assign/override/normal`;
      let response = await newFetch(POST, api_path, {
        associate_id: associate.id,
      });

      if (response.success) {
        ToastUtil.success(response.message);
        setActiveSidebar(false);
        await fetchSchedules(activeSite.id);
      }
    }
  };

  const assignOverrideFixedShiftHandler = async () => {
    const isConfirmed = await AlertService.confirm(
      '',
      'Are you sure you want to assign this Employee to this shift as Fixed Shift? This will override all the scheduling rules.'
    );
    if (isConfirmed) {
      let api_path = `/associate/shifts/${activeSchedule.id}/assign/override/fixed`;
      let response = await newFetch(POST, api_path, {
        associate_id: associate.id,
      });

      if (response.success) {
        ToastUtil.success(response.message);
        setActiveSidebar(false);
        await fetchSchedules(activeSite.id);
      }
    }
  };

  const reassignShiftHandler = async () => {
    const isConfirmed = await AlertService.confirm(
      '',
      'Are you sure you want to assign the Employee to this shift?'
    );
    if (isConfirmed) {
      let data = {
        status: '1',
        associate_ids: [associate.id],
      };

      let api_path = `/schedule/${activeSchedule.id}/associate_update`;
      let response = await newFetch(PUT, api_path, data);

      ToastUtil.success(response.message);
      if (response.success) {
        setActiveSidebar(false);
        await fetchSchedules(activeSite.id);
      }
    }
  };

  const checkboxHandler = (e, type) => {
    const { checked } = e.target;

    switch (type) {
      case 'overtime_after':
        setIsOvertimeAfter(checked);
        break;

      case 'overtime_before':
        setIsOvertimeBefore(checked);
        break;

      case 'undertime':
        setIsUndertime(checked);
        break;

      default:
        break;
    }
  };

  const calculateOvertime = () => {
    if (!associateStatus) return 0;

    const shiftStart = moment(
      `${associateStatus.schedule.date} ${associateStatus.schedule.shift.start_time}`,
      'YYYY-MM-DD HH:mm'
    );
    const shiftEnd = moment(
      `${associateStatus.schedule.date} ${associateStatus.schedule.shift.end_time}`,
      'YYYY-MM-DD HH:mm'
    );

    const timeInMoment = timeIn
      ? moment(`${dateTimeIn} ${timeIn}`, 'YYYY-MM-DD HH:mm')
      : null;
    const timeOutMoment = timeOut
      ? moment(`${dateTimeOut} ${timeOut}`, 'YYYY-MM-DD HH:mm')
      : null;

    let workedHours = 0;
    if (timeInMoment && timeOutMoment) {
      workedHours = moment.duration(timeOutMoment.diff(timeInMoment)).asHours();
    }

    let overtimeHours = 0;

    // Check if it's weekend (0 = Sunday, 6 = Saturday)
    const shiftDate = moment(associateStatus.schedule.date);
    const isWeekend = shiftDate.day() === 0 || shiftDate.day() === 6;

    // Set Breaktime default for Weekday if more than 8hrs
    if (!isWeekend) {
      if (workedHours > 8) {
        setTotalBreak(60);
        setExceedWorkHours(true);
      } else {
        setTotalBreak(0);
        setExceedWorkHours(false);
      }
    }

    if (isWeekend && timeInMoment && timeOutMoment) {
      // Weekend: All worked hours are considered overtime
      overtimeHours = workedHours;

      // Weekend OT > 8hrs, subtracting 1 hour for lunch break
      if (overtimeHours > 8) {
        setExceedOverTime(true);
        overtimeHours = overtimeHours - 1;
      } else setExceedOverTime(false);
    } else {
      // Weekday: Calculate before and after overtime as usual

      // If neither overtime checkboxes are checked, set overtime to 0
      if (!isOvertimeBefore && !isOvertimeAfter) {
        overtimeHours = 0;
      } else {
        // Calculate overtime only if checkboxes are selected
        if (isOvertimeBefore && timeInMoment) {
          const diffBefore = shiftStart.diff(timeInMoment, 'hours', true);
          if (diffBefore > 0) overtimeHours += diffBefore;
        }
        if (isOvertimeAfter && timeOutMoment) {
          const diffAfter = timeOutMoment.diff(shiftEnd, 'hours', true);
          if (diffAfter > 0) overtimeHours += diffAfter;
        }

        if (overtimeHours > 8) {
          setExceedOverTime(true);
          overtimeHours = overtimeHours - 1;
        } else setExceedOverTime(false);
      }
    }

    setTotalOvertime(overtimeHours);
    return overtimeHours; // Return the calculated value
  };

  const handleUpdateShiftStatus = async (e) => {
    e.preventDefault();

    if (!status) {
      ToastUtil.error('Please select status.');
      return false;
    }

    const isInvalid = (val) => !val || val === 'Invalid date';

    if (
      [2, 3, 4, 5].includes(Number(status)) &&
      (isInvalid(dateTimeIn) ||
        isInvalid(timeIn) ||
        isInvalid(dateTimeOut) ||
        isInvalid(timeOut))
    ) {
      ToastUtil.error('Please enter time in and time out.');
      return false;
    }

    // Validate that dateTimeIn must match activeSchedule.date
    if (dateTimeIn) {
      const inputDate = moment(dateTimeIn, 'YYYY-MM-DD').format('YYYY-MM-DD');
      const scheduleDate = moment(activeSchedule?.date, 'YYYY-MM-DD').format(
        'YYYY-MM-DD'
      );

      if (inputDate !== scheduleDate) {
        ToastUtil.error('Time In date must be the same as the shift date.');
        return false;
      }
    }

    // Get shift and time data (used for validation and flag setting)
    const shiftStart = moment(
      `${associateStatus.schedule.date} ${associateStatus.schedule.shift.start_time}`,
      'YYYY-MM-DD HH:mm'
    );
    const shiftEnd = moment(
      `${associateStatus.schedule.date} ${associateStatus.schedule.shift.end_time}`,
      'YYYY-MM-DD HH:mm'
    );

    const timeInMoment = timeIn
      ? moment(`${dateTimeIn} ${timeIn}`, 'YYYY-MM-DD HH:mm')
      : null;
    const timeOutMoment = timeOut
      ? moment(`${dateTimeOut} ${timeOut}`, 'YYYY-MM-DD HH:mm')
      : null;

    const shiftDate = moment(associateStatus.schedule.date);
    const isWeekend = shiftDate.day() === 0 || shiftDate.day() === 6;

    // Validation
    if (isOvertimeBefore && !timeIn) {
      ToastUtil.error('Time In is required for Overtime - Before Shift.');
      return false;
    }
    if (isOvertimeAfter && !timeOut) {
      ToastUtil.error('Time Out is required for Overtime - After Shift.');
      return false;
    }

    const overtimeHours = calculateOvertime();

    const isConfirmed = await AlertService.confirm(
      '',
      "Are you sure you want to update this Employee's shift status?"
    );
    if (!isConfirmed) return;

    let data = {
      status: Number(status),
      associate_ids: [associate.id],
      associate_role_id: statusRole,
      is_overtime_after: isOvertimeAfter,
      is_overtime_before: isOvertimeBefore,
      is_undertime: isUndertime,
      total_break: totalBreak,
      remarks: remarksMps,
      total_overtime: overtimeHours,
    };

    if (timeIn) {
      data.time_in = timeInMoment.format('YYYY-MM-DD HH:mm');
    }
    if (timeOut) {
      data.time_out = timeOutMoment.format('YYYY-MM-DD HH:mm');
    }
    if (breakIn) {
      data.break_in = moment(`${dateBreakIn} ${breakIn}`).format(
        'YYYY-MM-DD HH:mm'
      );
    }
    if (breakOut) {
      data.break_out = moment(`${dateBreakOut} ${breakOut}`).format(
        'YYYY-MM-DD HH:mm'
      );
    }

    if (associateStatus) {
      data.oldData = {
        status: associateStatus.statusObj.id,
        time_in: associateStatus.time_in,
        time_out: associateStatus.time_out,
        break_in: associateStatus.break_in,
        break_out: associateStatus.break_out,
      };
    }

    let api_path = `/schedule/${associateStatus.schedule_id}/associate_update`;
    let response = await newFetch(PUT, api_path, data);

    ToastUtil.success(response.message);
    if (response.success) {
      setActiveSidebar(false);
      await fetchSchedules(activeSite.id);
    }
  };

  useEffect(() => {
    fetchStatuses();
    fetchRollCall();
  }, []);

  useEffect(() => {
    if (associateStatus?.schedule?.date) {
      const shiftDate = moment(associateStatus.schedule.date);
      setDayOfWeek(shiftDate.format('dddd'));
    }
  }, [associateStatus?.schedule?.date]);

  useEffect(() => {
    calculateOvertime();
  }, [timeIn, timeOut, isOvertimeBefore, isOvertimeAfter]);

  return (
    <div className="status-tab-container w-100 mt-4">
      {associateStatus ? (
        <React.Fragment>
          {activeSite.enable_roll_calls == true ? (
            associateStatus.notifications &&
            associateStatus.notifications.length > 0 ? (
              <div className="table-responsive border rounded">
                <table className="table mb-0">
                  <thead>
                    <tr>
                      <th className="border-top-0 border-bottom-0 border-right">
                        Notification
                      </th>
                      <th className="border-top-0 border-bottom-0 border-right text-center">
                        Sent
                      </th>
                      <th className="border-top-0 border-bottom-0 text-center">
                        Acknowledged
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {associateStatus?.notifications &&
                    associateStatus?.notifications.length > 0 ? (
                      associateStatus.notifications.map(
                        (notification, index) => (
                          <tr key={index}>
                            <td className="border-right border-bottom fw-bold">
                              {notification.rollcall.title}
                            </td>
                            <td className="border-right text-center">
                              {notification.is_read ? (
                                <i className="fas fa-check text-brand" />
                              ) : (
                                <i className="fas fa-times text-danger" />
                              )}
                            </td>
                            <td className="text-center">
                              <div className="text-brand ms-2">
                                {notification.is_acknowledged ? (
                                  to12Hr(moment(notification.updatedAt))
                                ) : (
                                  <div style={{ color: '#212529' }}>NA</div>
                                )}
                              </div>
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <div className="dropdown-item">No results</div>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              ''
            )
          ) : (
            ''
          )}

          <div className="user-contact-info-container">
            <div>
              <span>Fixed Shift:</span>
            </div>
            <div>
              <span>{associateStatus.is_fixed ? 'Yes' : 'No'}</span>
            </div>
          </div>

          <div className="user-contact-info-container">
            <div>
              <span>Punched In:</span>
            </div>
            <div>
              <span>
                {moment(associateStatus.time_in, 'YYYY-MM-DD HH:mm').isValid()
                  ? moment(associateStatus.time_in, 'YYYY-MM-DD HH:mm').format(
                      'hh:mm a'
                    )
                  : '-'}

                {moment(
                  associateStatus.time_out,
                  'YYYY-MM-DD HH:mm'
                ).isValid() &&
                  `-${moment(
                    associateStatus.time_out,
                    'YYYY-MM-DD HH:mm'
                  ).format('hh:mm a')}`}
              </span>
            </div>
          </div>

          <div className="user-contact-info-container">
            <div>
              <span>Total Break:</span>
            </div>
            <div>
              <span>{associateStatus.total_break || 0} mins</span>
            </div>
          </div>

          {activeSchedule && activeSite.enable_geolocation === true && (
            <>
              <div className="user-contact-info-container">
                <div>
                  <span>Punched In Location:</span>
                </div>
                <div>
                  <span>
                    {associateStatus.timein_location
                      ? associateStatus.timein_location
                      : 'Location was not recorded'}
                  </span>
                </div>
              </div>
              <div className="user-contact-info-container">
                <div>
                  <span>Punched Out Location:</span>
                </div>
                <div>
                  <span>
                    {associateStatus.timeout_location
                      ? associateStatus.timeout_location
                      : 'Location was not recorded'}
                  </span>
                </div>
              </div>
            </>
          )}
          <div
            className="user-contact-info-container"
            style={{ marginTop: '2rem' }}
          >
            <div>
              <span>Status:</span>
            </div>
            <div
              className={
                associateStatus.status === 1 ||
                associateStatus.status === 2 ||
                associateStatus.status === 3 ||
                associateStatus.status === 4
                  ? 'text-success'
                  : 'text-danger'
              }
            >
              {associateStatus.statusObj.status}{' '}
              {associateStatus.schedule.extension &&
                associateStatus.schedule.extension.associates.find(
                  (extensionAssociate) =>
                    extensionAssociate.associate_id === associate.id
                ) &&
                `(Extended by ${(
                  parseInt(associateStatus.schedule.extension.minutes) / 60
                ).toFixed(1)} Hour(s))`}
              {type !== 'client' && (
                <button
                  className="btn btn-sm btn-outline-brand ms-2"
                  onClick={handleOpenModal}
                >
                  <i className="fas fa-edit"></i>
                </button>
              )}
            </div>
          </div>
          {(associateStatus.status === 6 || associateStatus.status === 7) &&
            associateStatus.reason && (
              <div
                className="user-contact-info-container"
                style={{ marginTop: '2rem' }}
              >
                <div>
                  <span>Reason:</span>
                </div>
                <div>{associateStatus.reason}</div>
              </div>
            )}

          {associateStatus.attachment && (
            <div
              className="user-contact-info-container"
              style={{ marginTop: '2rem' }}
            >
              <div>
                <span>Attachment:</span>
              </div>
              <div>
                <a
                  href={`${SERVER_URL}/${associateStatus.attachment}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Open
                </a>
              </div>
            </div>
          )}

          {associateStatus.status === 1 && type !== 'client' && (
            <div className="text-center mt-4">
              <button className="btn btn-danger" onClick={cancelShiftHandler}>
                Cancel shift
              </button>
            </div>
          )}

          {activeSchedule.filled_slots < activeSchedule.slots.slots &&
            (associateStatus.status === 6 || associateStatus.status === 7) &&
            type !== 'client' && (
              <div className="text-center mt-4">
                <button
                  className="btn btn-danger"
                  onClick={reassignShiftHandler}
                >
                  Reassign shift
                </button>
              </div>
            )}

          <div className="flex-grow-1">
            <div className="mt-4">
              <strong className="mt-4">Activity Logs</strong>
            </div>
            <div className="rounded shadow bg-white mt-2 p-4">
              {associateStatusLogs.length > 0
                ? associateStatusLogs.map((log, index) => (
                    <div
                      key={index}
                      className="d-flex flex-row py-1 align-items-center"
                      style={{ fontSize: 12 }}
                    >
                      <div className="text-muted" style={{ width: '140px' }}>
                        {log.createdAt}
                      </div>
                      <div className="flex-grow-1">{log.activity_logs}</div>
                      {log.capture_photo && (
                        <div className="ms-2">
                          <a
                            href={`${SERVER_URL}/${log.capture_photo}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-flex align-items-center"
                          >
                            <img
                              src={docImg}
                              alt="Capture Photo"
                              className="me-2"
                              style={{
                                width: '24px',
                                height: '24px',
                                cursor: 'pointer',
                              }}
                              title="View captured photo"
                            />
                          </a>
                        </div>
                      )}
                    </div>
                  ))
                : 'No activity logs.'}
            </div>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="d-flex justify-content-between border-bottom">
            <strong>Status</strong>
            <p className="text-muted">Not Assigned</p>
          </div>
          {activeSchedule || activeSite.enable_br_upload === false ? (
            <div className="d-flex flex-column mt-4">
              <div className="text-center">
                <button
                  className="btn btn-brand"
                  onClick={() => {
                    if (
                      associate.client !== undefined &&
                      activeSite.enable_assign_multiple_roles
                    ) {
                      setOpenEditRoleModal(true);
                    } else {
                      setConfirmApplyShiftModal(true);
                    }
                  }}
                >
                  Assign to this shift
                </button>
              </div>
              {activeSite.enable_br_upload === true ? (
                <div className="d-flex justify-content-center mt-4">
                  <button
                    className="btn btn-outline-brand me-2"
                    onClick={assignOverrideShiftHandler}
                  >
                    Assign Normal (Override)
                  </button>
                  <button
                    className="btn btn-outline-brand ms-2"
                    onClick={assignOverrideFixedShiftHandler}
                  >
                    Assign Fixed (Override)
                  </button>
                </div>
              ) : (
                ''
              )}
            </div>
          ) : (
            ''
          )}
        </React.Fragment>
      )}
      <Modal showModal={openEditStatusModal} customStyle={style}>
        <form
          className="d-flex flex-column justify-content-between flex-grow-1 h-100"
          onSubmit={(e) => handleUpdateShiftStatus(e)}
        >
          <h5 className="mb-3">
            Update Shift Status (
            {activeSchedule?.date &&
              new Date(activeSchedule.date).toLocaleDateString('en-GB')}
            ) &nbsp; | &nbsp;
            <span className="fw-bold">{activeSchedule?.shift?.name}</span>
            &nbsp; | &nbsp;
            {activeSchedule?.shift?.start_time} –{' '}
            {activeSchedule?.shift?.end_time}
          </h5>

          <div className="d-flex flex-column mt-2">
            <div className="mb-2">
              <label htmlFor="shiftStatus">Status</label>
              <select
                name="shiftStatus"
                id="shiftStatus"
                className="form-select"
                value={status}
                onChange={({ target: { value } }) => setStatus(Number(value))}
              >
                {statuses.length > 0 &&
                  statuses.map((status, index) => (
                    <option value={status.id} key={index}>
                      {status.status}
                    </option>
                  ))}
              </select>
            </div>
            <div className="row">
              <div className="col pe-3">
                <div className="row">
                  <div className="col-6 pe-0">
                    <div className="mb-2">
                      <label htmlFor="shiftTimeIn">Time In </label>
                      <input
                        name="dateTimeIn"
                        type="date"
                        className="form-control"
                        value={dateTimeIn}
                        onChange={(e) => dateTimeInHandler(e)}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mb-2">
                      <label htmlFor="shiftTimeIn">&nbsp;</label>
                      <input
                        type="time"
                        className="form-control"
                        id="shiftTimeIn"
                        placeholder="Shift Time In"
                        value={timeIn}
                        onChange={({ target: { value } }) => setTimeIn(value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col ps-3">
                <div className="row">
                  <div className="col-6 pe-0">
                    <div className="mb-2">
                      <label htmlFor="shiftTimeOut">Time Out</label>
                      <input
                        name="dateTimeOut"
                        type="date"
                        className="form-control"
                        value={dateTimeOut}
                        onChange={(e) => dateTimeOutHandler(e)}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mb-2">
                      <label htmlFor="shiftTimeOut">&nbsp;</label>
                      <input
                        type="time"
                        className="form-control"
                        id="dateTime"
                        placeholder="Shift Time Out"
                        value={timeOut}
                        onChange={({ target: { value } }) => setTimeOut(value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row">
              <div className="col pe-3">
                <div className="row">
                  <div className="col-6 pe-0">
                    <div className="mb-2">
                      <label htmlFor="totalBreak">Total Break</label>
                      <input
                        name="totalBreak"
                        type="text"
                        className="form-control"
                        value={totalBreak}
                        onChange={({ target: { value } }) =>
                          setTotalBreak(value)
                        }
                      />
                    </div>
                  </div>
                  <div className="col-6 mins-text">minutes</div>
                </div>
              </div>
              <div className="col ps-3">&nbsp;</div>
            </div> */}
            <div className="row">
              <div className="mb-2">
                <div className="col-3 pe-0">
                  <label htmlFor="totalBreak">
                    Total Break: {totalBreak}min
                  </label>
                </div>
              </div>
            </div>
            {associate.client !== undefined &&
              activeSite.enable_assign_multiple_roles && (
                <div className="mb-2">
                  <label htmlFor="role">Position</label>
                  <select
                    name="role"
                    id="role"
                    className="form-control"
                    value={statusRole || ''}
                    onChange={({ target: { value } }) => setStatusRole(value)}
                  >
                    {associate_roles &&
                      associate_roles.map((role) => (
                        <option key={role.id} value={role.id}>
                          {role.role} - {role.pb_jo_no}
                        </option>
                      ))}
                  </select>
                </div>
              )}
            {(status === 2 || status === 3) && (
              <>
                {' '}
                <div className="row mt-2">
                  <div className="col">
                    <div className="d-flex">
                      <label htmlFor="is_overtime_before">
                        <input
                          type="checkbox"
                          className="me-2"
                          id="is_overtime_before"
                          checked={isOvertimeBefore}
                          value={isOvertimeBefore}
                          onChange={(e) =>
                            checkboxHandler(e, 'overtime_before')
                          }
                        />
                        Overtime - Before Shift
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="d-flex">
                      <label htmlFor="is_overtime_after">
                        <input
                          type="checkbox"
                          className="me-2"
                          id="is_overtime_after"
                          checked={isOvertimeAfter}
                          value={isOvertimeAfter}
                          onChange={(e) => checkboxHandler(e, 'overtime_after')}
                        />
                        Overtime - After Shift
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col">
                    <div className="d-flex">
                      <label htmlFor="is_undertime">
                        <input
                          type="checkbox"
                          className="me-2"
                          id="is_undertime"
                          checked={isUndertime}
                          value={isUndertime}
                          onChange={(e) => checkboxHandler(e, 'undertime')}
                        />
                        Undertime
                      </label>
                    </div>
                  </div>
                </div>
                {totalOvertime > 0 && (
                  <div className="row mt-2">
                    <div className="col">
                      <label className="fw-bold">Calculated Overtime</label>
                      <div>
                        {dayOfWeek} - {totalOvertime.toFixed(2)} hrs{' '}
                        {exceedOvertime && (
                          <span className="text-danger">(-1h break)</span>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <div className="row mt-3">
                  <div className="col">
                    <label htmlFor="remarks_mps">Remarks for MPS</label>
                    <textarea
                      id="remarks_mps"
                      name="remarks_mps"
                      className="form-control"
                      rows={3}
                      value={remarksMps}
                      onChange={({ target: { value } }) => setRemarksMps(value)}
                      placeholder="Enter remarks..."
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="d-flex justify-content-end mt-auto pt-3 border-top">
            <button
              type="button"
              onClick={() => {
                setOpenEditStatusModal(false);
                setBackDropSidebar(true);
              }}
              className="btn btn-outline-brand"
              style={{ width: '12rem' }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-brand ms-3"
              style={{ width: '12rem' }}
            >
              Update
            </button>
          </div>
        </form>
      </Modal>
      <Modal showModal={openEditRoleModal} customStyle={roleStyle}>
        <Row className="mb-3">
          <Form.Group as={Col} md="12">
            <strong>
              Do you want to assign the employee to this position?
            </strong>
            <Form.Control
              as="select"
              type="select"
              name="role"
              onChange={(e) => {
                setSelectedRole(e.target.value);
              }}
              style={{
                marginTop: 15,
              }}
            >
              <option value=""> Please select a position.</option>
              {associate_roles &&
                associate_roles.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.role} - {role.pb_jo_no}
                  </option>
                ))}
            </Form.Control>
            {clickYesAssignRole && !selectedRole && (
              <>
                <span style={{ fontSize: 12, color: 'red' }}>
                  Position is required.
                </span>
                <br />
              </>
            )}
          </Form.Group>
        </Row>
        <Row className="d-flex justify-content-end mt-auto pt-3 border-top">
          <button
            type="button"
            onClick={() => {
              setOpenEditRoleModal(false);
              setConfirmApplyShiftModal(true);
              setSelectedRole(null);
            }}
            className="btn btn-outline-brand"
            style={{ width: '8rem' }}
          >
            No
          </button>
          <button
            type="button"
            className="btn btn-brand ms-3"
            style={{ width: '8rem' }}
            onClick={() => {
              if (selectedRole) {
                setOpenEditRoleModal(false);
                setConfirmApplyShiftModal(true);
              }
              setClickYesAssignRole(true);
            }}
          >
            Yes
          </button>
        </Row>
      </Modal>
      <Modal showModal={confirmApplyShiftModal} customStyle={roleStyle}>
        <Row className="mb-3">
          <p>Are you sure you want to assign the employee to this shift?</p>
        </Row>
        <Row className="d-flex justify-content-end mt-auto pt-3 border-top">
          <button
            type="button"
            onClick={() => {
              setConfirmApplyShiftModal(false);
              setSelectedRole(null);
              setClickYesAssignRole(false);
            }}
            className="btn btn-outline-brand"
            style={{ width: '8rem' }}
          >
            No
          </button>
          <button
            type="button"
            className="btn btn-brand ms-3"
            style={{ width: '8rem' }}
            onClick={() => {
              setClickYesAssignRole(false);
              assignShiftHandler();
            }}
          >
            Yes
          </button>
        </Row>
      </Modal>
    </div>
  );
};

export default StatusTab;
